import request from '@/utils/request';
import { notificationsEndpoint } from '@/constants/urls';

const notifications = (category, code, event, filter, page, pageSize) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  return (
    request({
      url: notificationsEndpoint(category, code, event),
      params,
      method: 'GET',
    })
  );
};

const create = (entity, code, event, properties) => (
  request({
    url: notificationsEndpoint(entity, code, event),
    data: properties,
    method: 'POST',
  })
);

const NotificationsService = {
  create,
  notifications,
};

export default NotificationsService;
